/*global gtag, fbq*/
/*eslint no-undef: "error"*/

import Swup from 'swup';
import WOW from 'wow.js';
import Toastify from 'toastify-js';
import SwupScrollPlugin from '@swup/scroll-plugin';
import SwupLivewirePlugin from '@swup/livewire-plugin';
import { loadListeners } from './pages-scripts';
import { Tooltip } from 'bootstrap';
import React from 'react';
import ReactDOM from 'react-dom/client';
import DrawPrescription from './components/DrawPrescription';

window.DrawPrescription = DrawPrescription;

let reactRoot = null;

window.openReactModal = function (data) {
    const { quote, productsLen } = data;
    const container = document.getElementById('react-modal-container');
    if (!container) {
        console.error('No se encontró el contenedor de React.');
        return;
    }

    if (!reactRoot) {
        reactRoot = ReactDOM.createRoot(container.querySelector('.modal-content'));
    }

    reactRoot.render(React.createElement(DrawPrescription, { visible: true, product: null, quotation: quote, productsLen: productsLen }));
};

const showToast = (message, options) => {
    const close = options && options.close;
    const icon = options && options.icon;
    const text = icon === undefined ? message : `<i class="${icon}"></i> ${message}`;

    const toastify = Toastify({
        text: text,
        duration: (options && options.duration) || 5000,
        close: close === true || close === undefined,
        gravity: 'bottom',
        position: 'right',
        stopOnFocus: true, // Prevents dismissing of toast on hover
        className: (options && options.style) || 'info',
        escapeMarkup: icon === undefined,
    });

    toastify.showToast();
    return toastify;
};

const hideToast = (toast) => {
    toast.hideToast();
};

// var lastPage = null;

const loadWhatsappButton = async () => {
    // Boton de chat whatsapp
    var wa_btnSetting = {
        btnColor: '#12324a',
        ctaText: '',
        cornerRadius: 40,
        marginBottom: 20,
        marginLeft: 20,
        marginRight: 20,
        btnPosition: 'right',
        whatsAppNumber: '56977080257',
        welcomeMessage: '¡Hola! Estoy interesado en tu servicio',
        zIndex: 1040,
        btnColorScheme: 'light',
    };

    var wa_widgetSetting = {
        title: 'Narma',
        subTitle: 'En línea',
        headerBackgroundColor: '#D26C37',
        headerColorScheme: 'light',
        greetingText: '¡Hola! ¿Cómo podemos ayudarte?',
        ctaText: 'Continuar en Whatsapp',
        btnColor: '#154261',
        cornerRadius: 40,
        welcomeMessage: 'Hello',
        btnColorScheme: 'light',
        // brandImage: window.location.origin + '/images/narma.png',
        brandImage: 'https://www.narma.cl/images/narma.png',
        darkHeaderColorScheme: {
            title: '#333333',
            subTitle: '#4F4F4F',
        },
    };

    const MAX_RETRIES = 10;
    let retries = 0;
    while (retries <= MAX_RETRIES) {
        try {
            _waEmbed(wa_btnSetting, wa_widgetSetting); // eslint-disable-line
            break;
        } catch {
            await new Promise((r) => setTimeout(r, 2000));
        }
        retries++;
    }
};

(() => {
    const isVisible = (element) => {
        return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
    };

    const invalidRutsExceptions = ['26963300-5', '10097913-9'];

    // eslint-disable-next-line no-unused-vars
    window.validateRut = (rutCompleto) => {
        if (invalidRutsExceptions.includes(rutCompleto)) {
            return true;
        }

        if (((rutCompleto === undefined) === rutCompleto) === null || rutCompleto === '') {
            return false;
        }

        const dv = (T) => {
            var M = 0,
                S = 1;
            for (; T; T = Math.floor(T / 10)) S = (S + (T % 10) * (9 - (M++ % 6))) % 11;
            return S ? S - 1 : 'k';
        };

        if (!/^(\d){7,8}-[\dkK]$/.test(rutCompleto)) {
            return false;
        }

        var tmp = rutCompleto.split('-');
        var digv = tmp[1];
        var rut = tmp[0];
        if (digv == 'K') digv = 'k';
        return dv(rut) == digv;
    };

    window.validateRutNull = (rutCompleto) => {
        if (invalidRutsExceptions.includes(rutCompleto)) {
            return true;
        }

        if (((rutCompleto === undefined) === rutCompleto) === null || rutCompleto === '') {
            return true;
        }

        const dv = (T) => {
            var M = 0,
                S = 1;
            for (; T; T = Math.floor(T / 10)) S = (S + (T % 10) * (9 - (M++ % 6))) % 11;
            return S ? S - 1 : 'k';
        };

        if (!/^(\d){7,8}-[\dkK]$/.test(rutCompleto)) {
            return false;
        }

        var tmp = rutCompleto.split('-');
        var digv = tmp[1];
        var rut = tmp[0];
        if (digv == 'K') digv = 'k';
        return dv(rut) == digv;
    };

    // Validates the form only on visible inputs
    const validateForm = (form) => {
        let valid = true;
        for (let element of form.elements) {
            if (isVisible(element)) {
                const customValidation = element.getAttribute('data-custom-validation');
                let validElement = false;

                if (customValidation) {
                    const validationCall = customValidation + "('" + element.value + "')";
                    const isValid = eval(validationCall);

                    element.classList.remove('is-valid');
                    element.classList.remove('is-invalid');

                    if (!isValid) {
                        validElement = false;
                        element.classList.add('is-invalid');
                        element.setCustomValidity('Invalid');
                    } else {
                        validElement = true;
                        element.classList.add('is-valid');
                        element.setCustomValidity('');
                    }
                } else {
                    validElement = element.checkValidity();
                }

                if (element.name === 'confirmPassword') {
                    const passwordInput = form.querySelector('input[name="password"]');
                    if (passwordInput && passwordInput.value !== element.value) {
                        validElement = false;
                        element.classList.add('is-invalid');
                        element.setCustomValidity('Passwords do not match');
                        element.nextElementSibling.textContent = 'Las contraseñas no coinciden';
                    } else {
                        element.classList.remove('is-invalid');
                        element.setCustomValidity('');
                    }
                }

                valid = valid && validElement;
            }
        }

        return valid;
    };

    const setupForms = () => {
        // Fetch all the forms we want to apply custom Bootstrap validation styles to
        let forms = document.querySelectorAll('.needs-validation');

        // Loop over them and prevent submission
        Array.from(forms).forEach((form) => {
            form.addEventListener(
                'submit',
                (event) => {
                    if (!validateForm(form)) {
                        event.preventDefault();
                        event.stopPropagation();
                    } else {
                        if (form.matches('#formResetPassword, #formSendResetLink')) {
                            event.preventDefault();
                            handlePasswordResetForms(form);
                        }
                    }

                    form.classList.add('was-validated');
                },
                false
            );
        });

        forms = document.querySelectorAll('.ajax-submit');
        Array.from(forms).forEach((form) => {
            // Verifica si el formulario ya tiene algún listener para el evento submit
            const hasSubmitListener = !!form._hasSubmitListener;
            if (!hasSubmitListener) {
                form._hasSubmitListener = true;
            } else {
                return;
            }

            form.addEventListener('submit', (evt) => {
                evt.preventDefault();

                if (validateForm(form)) {
                    form.classList.add('form-in-process');
                    let msg = form.getAttribute('data-sending-message') || 'Enviando...';
                    const sendToastify = showToast(msg, { icon: 'fa-solid fa-circle-notch fa-spin', duration: -1, close: false });

                    fetch(form.action, {
                        method: form.method,
                        body: new FormData(form),
                    })
                        .then((response) => {
                            hideToast(sendToastify);

                            if (response.status === 200) {
                                let msg = form.getAttribute('data-success-message') || 'Enviado correctamente';
                                showToast(msg, { icon: 'fa-solid fa-check' });

                                const preservedInput = form.getAttribute('data-preserve-after-reset');
                                if (preservedInput) {
                                    const preservedValue = form.elements[preservedInput].value;
                                    form.reset();
                                    form.elements[preservedInput].value = preservedValue;
                                } else {
                                    form.reset();
                                }

                                form.classList.remove('was-validated', 'form-in-process');

                                if (form.id == 'patientForm') {
                                    window.livewire.emit('submittedPatient');
                                } else if (form.id == 'doctorForm') {
                                    window.livewire.emit('submittedDoctor');
                                } else if (form.id == 'diagnosticForm') {
                                    window.livewire.emit('submittedDiagnostic');
                                }
                            } else {
                                let msg = form.getAttribute('data-error-message') || 'Ha ocurrido un error. Intenta nuevamente';
                                showToast(msg, { style: 'error', icon: 'bi bi-exclamation-circle' });
                                form.classList.remove('form-in-process');
                            }
                        })
                        .catch(() => {
                            let msg = form.getAttribute('data-error-message') || 'Ha ocurrido un error. Intenta nuevamente';
                            showToast(msg, { style: 'error', icon: 'bi bi-exclamation-circle' });
                            form.classList.remove('form-in-process');
                        });
                }
            });
        });
    };

    const showModal = (title, message, status = 'success', redirect = false) => {
        //const modalTitle = document.querySelector("#responseFormModal .modal-title");
        const modalBody = document.querySelector('#responseFormModal .modal-body');
        const closeButton = document.querySelector('#responseFormModal .btn-redirect');
        const modal = new window.bootstrap.Modal(document.getElementById('responseFormModal'));
        //modalTitle.textContent = title;

        const icon =
            status === 'success'
                ? '<i class="bi bi-check-circle-fill text-success fs-2 me-2"></i>'
                : '<i class="bi bi-x-circle-fill text-danger fs-2 me-2"></i>';

        modalBody.innerHTML = `
            <div class="d-flex flex-column align-items-center justify-content-center text-center lead">
                ${icon}
                <span>${message}</span>
            </div>
        `;

        closeButton.onclick = () => {
            if (redirect) {
                window.location.href = document.querySelector('meta[name=root]').content + '/login?r=' + Math.random().toString(36).substring(2, 12);
            } else {
                modal.hide();
            }
        };

        modalBody.querySelectorAll('a').forEach((link) => {
            link.addEventListener('click', () => {
                modal.hide();
            });
        });

        modal.show();
    };

    const handlePasswordResetForms = async (form) => {
        const formData = new FormData(form);
        const submitButton = form.querySelector("button[type='submit']");
        submitButton.disabled = true;

        try {
            const response = await fetch(form.action, {
                method: form.method,
                body: formData,
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    Accept: 'application/json',
                },
            });

            const data = await response.json();

            if (data.status === 'success') {
                if (form.matches('#formResetPassword')) {
                    showModal('Éxito', data.message, 'success', true);
                } else {
                    showModal('Éxito', data.message, 'success');
                }

                form.reset();
            } else {
                const errorMessages = data.errors ? data.errors.join('<br>') : data.message;
                showModal('Error', errorMessages, 'error');
            }
        } catch (error) {
            showModal('Error', 'Ha ocurrido un error. Intenta nuevamente.', 'error');
        } finally {
            submitButton.disabled = false;
        }
    };

    const enableBodyScrollingDisabledByBootstrapOffcanvas = () => {
        document.body.style.overflow = '';
        document.body.style.paddingRight = '';
    };

    const init = () => {
        // An ugly patch
        enableBodyScrollingDisabledByBootstrapOffcanvas();

        const preloader = document.querySelector('.preloader');
        if (preloader) {
            preloader.classList.add('loaded');
        }

        setupForms();

        Object.entries(loadListeners).forEach(([selector, listener]) => {
            if (document.querySelector(selector)) {
                listener();
            }
        });

        // Habilita los tooltips
        var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
        tooltipTriggerList.map(function (tooltipTriggerEl) {
            return new Tooltip(tooltipTriggerEl);
        });

        notifyPageChanged(window.location.pathname);
    };

    // Registra eventos para GoogleAds y FacebookPixel
    const notifyPageChanged = (page) => {
        gtag('set', 'page_path', page);
        gtag('event', 'page_view');

        fbq('track', 'PageView');
    };

    const unload = () => {
        const preloader = document.querySelector('.preloader');
        if (preloader) {
            preloader.classList.remove('loaded');
        }
    };

    window.addEventListener('load', init);

    // Fade in/out al cambiar entre paginas
    const swup = new Swup({
        plugins: [
            new SwupScrollPlugin({
                animateScroll: {
                    betweenPages: false,
                    samePageWithHash: false,
                    samePage: false,
                },
            }),
            new SwupLivewirePlugin(),
        ],
        animateHistoryBrowsing: true,
    });
    swup.on('contentReplaced', init);
    swup.on('transitionStart', unload);

    // Animaciones al hacer scroll
    new WOW().init();

    loadWhatsappButton();
})();
